import { useQuery } from '@tanstack/react-query';

import { courseConst, ICoursesCategory } from 'modules/courses';
import { $apiV2 } from 'modules/global';

export const getCoursesCategory = () => async () => {
  const { data } = await $apiV2.get(`/category-course/select`);

  return { coursesCategory: data?.data };
};

export const useCoursesCategory = () => {
  const { data, ...args } = useQuery<{ coursesCategory: ICoursesCategory[] }>({
    queryKey: [courseConst.queryKeys.COURSES_CATEGORY],
    queryFn: getCoursesCategory()
  });

  return { ...data, ...args };
};
